import api from "../../../shared/services/api";
import { toast } from "react-toastify";

export async function loadSessoesService(setSessoes, setLoading) {
    setLoading(true);
    try {
        const response = await api.get("/whatsapp/sessoes");
        setSessoes(response.data);
    } catch (err) {
        toast.error("Erro ao carregar sessões");
        console.error(err);
    } finally {
        setLoading(false);
    }
}

export async function createSessaoService(nome, numero, provider = "whatsmeow") {
    const response = await api.post("/whatsapp/sessoes", { nome, numero, provider });
    return response.data;
}

export async function getQrCodeService(sessionName) {
    const response = await api.get(`/whatsapp/sessoes/qr/${sessionName}`);
    return response.data;
}

export async function reconnectQrCodeService(sessionName) {
    const response = await api.post(`/whatsapp/sessoes/restart/${sessionName}`);
    return response.data;
}

export async function getStatusService(sessionName) {
    const response = await api.get(`/whatsapp/sessoes/status/${sessionName}`);
    return response.data;
}

export async function deleteSessaoService(id) {
    await api.delete(`/whatsapp/sessoes/${id}`);
}

export async function sendTextService(sessionName, number, text) {
    const response = await api.post(`/whatsapp/sessoes/send-text`, { sessionName, number, text });
    return response.data;
}

export async function leaveAllGroupsService(sessionName) {
    const response = await api.post(`/whatsapp/sessoes/${sessionName}/sair-grupos`);
    return response.data;
}
